import { Injectable, inject } from '@angular/core';
import {
  COUNTRY_CONFIG,
  type Country,
  type CountryConfig,
  CURRENT_COUNTRY,
  type FeatureFlag,
  isFeatureEnabled,
} from './country.config';

@Injectable({ providedIn: 'root' })
export class CountryContext {
  readonly country: Country = inject(CURRENT_COUNTRY);
  readonly config: CountryConfig = COUNTRY_CONFIG[this.country];

  isEnabled(feature: FeatureFlag): boolean {
    return isFeatureEnabled(this.country, feature);
  }
}
